import React, { useState, useEffect } from "react";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  Toolbar,
  Typography,
  Checkbox,
  TextField,
} from "@mui/material";
import { visuallyHidden } from "@mui/utils";
import * as userService from "../../services/UserService";

const columns = [
  { id: "id", label: "ID", minWidth: 100 },
  { id: "name", label: "Nom", minWidth: 100 },
  { id: "surname", label: "Prénom", minWidth: 100 },
  { id: "fiantso", label: "Fiantsoana", minWidth: 100 },
  { id: "phone", label: "Téléphone", minWidth: 100 },
  { id: "email", label: "Email", minWidth: 100 },
];

function EnhancedTableToolbar(props) {
  const { numSelected, onFilterChange } = props;

  return (
    <Toolbar
      sx={{
        paddingLeft: { sm: 2 },
        paddingRight: { xs: 1, sm: 1 },
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <Typography variant="h6">Liste des Utilisateurs</Typography>
      <TextField
        label="Rechercher l'utilisateur"
        variant="outlined"
        size="medium" // You can adjust the size as needed
        onChange={(e) => onFilterChange(e.target.value)}
      />
      {numSelected > 0 ? (
        <Typography color="inherit" variant="subtitle1">
          {numSelected} sélectionné(s)
        </Typography>
      ) : null}
    </Toolbar>
  );
}

const TableUser = () => {
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("name");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [userData, setUserData] = useState([]);
  const [emptyRows, setEmptyRows] = useState(0);
  const [filter, setFilter] = useState(""); // État pour le filtre en temps réel

  useEffect(() => {
    userService
      .getAllUsers()
      .then((users) => {
        setUserData(users);
        const rowCount = Math.max(0, users.length - rowsPerPage * page);
        setEmptyRows(rowCount);
      })
      .catch((error) => {
        console.error(
          "Erreur lors de la récupération des utilisateurs :",
          error
        );
      });
  }, [rowsPerPage, page]);

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <Box sx={{ width: "80%" }}>
      <Paper sx={{ width: "100%", mb: 2 }}>
        <EnhancedTableToolbar onFilterChange={(value) => setFilter(value)} />
        <TableContainer>
          <Table sx={{ minWidth: 750 }} aria-labelledby="tableTitle">
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align="center"
                    padding="normal"
                    sortDirection={orderBy === column.id ? order : false}
                  >
                    <TableSortLabel
                      active={orderBy === column.id}
                      direction={orderBy === column.id ? order : "asc"}
                      onClick={() => handleRequestSort(column.id)}
                    >
                      {column.label}
                      {orderBy === column.id ? (
                        <Box component="span" sx={visuallyHidden}>
                          {order === "desc"
                            ? "tri décroissant"
                            : "tri croissant"}
                        </Box>
                      ) : null}
                    </TableSortLabel>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {userData
                .filter(
                  (user) =>
                    user.name.toLowerCase().includes(filter.toLowerCase()) ||
                    user.surname.toLowerCase().includes(filter.toLowerCase()) ||
                    user.phone.toLowerCase().includes(filter.toLowerCase()) ||
                    user.email.toLowerCase().includes(filter.toLowerCase()) ||
                    user.fiantso.toLowerCase().includes(filter.toLowerCase())
                )
                .filter((user) => user.role !== 'admin')
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row) => {
                  const labelId = `enhanced-table-checkbox-${row.id}`;

                  return (
                    <TableRow
                      hover
                      role="checkbox"
                      tabIndex={-1}
                      key={row.id}
                      sx={{ cursor: "pointer" }}
                    >
                      <TableCell
                        component="th"
                        id={labelId}
                        scope="row"
                        padding="normal" // Ajout du padding normal
                      >
                        {row.id}
                      </TableCell>
                      <TableCell component="th" scope="row" padding="normal">
                        {row.name}
                      </TableCell>
                      <TableCell component="th" scope="row" padding="normal">
                        {row.surname}
                      </TableCell>
                      <TableCell component="th" scope="row" padding="normal">
                        {row.fiantso}
                      </TableCell>
                      <TableCell component="th" scope="row" padding="normal">
                        {row.phone}
                      </TableCell>
                      <TableCell component="th" scope="row" padding="normal">
                        {row.email}
                      </TableCell>
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={userData.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
    </Box>
  );
};

export default TableUser;
